import React, { useState, useEffect } from "react";
import EmployeeNumberConfigSection from "./EmployeeNumberConfigSection";
import TagEditorPage from "./TagEditorPage";
import DropdownManager from "./DropdownManager";
import InterviewManager from "./InterviewManager";
import TrainingQuiz from "./TrainingQuiz";
import CustomTaskCreateHelper from "./CustomTaskCreateHelper";
import ReferenceCheckAdminPage from "./ReferenceCheckAdminPage";
import useAccess from "../../hooks/useAccess";
import "../../styles/AccountSettingsPage.css"; // Scoped CSS for this page only

const AccountSettingsPage = () => {
  const { hasPermission } = useAccess();
  const [tab, setTab] = useState(
    () => localStorage.getItem("accountSettingsTab") || "profile"
  );

  // ✅ Add a body class only while this page is mounted
  useEffect(() => {
    document.body.classList.add("account-settings-mode");
    return () => {
      document.body.classList.remove("account-settings-mode");
    };
  }, []);

  const TABS = [
    { key: "profile", label: "Profile" },
    { key: "tags", label: "Tags" },
    { key: "dropdownManager", label: "Dropdown Manager" },
    { key: "interviewQuestion", label: "Interview Question" },
    { key: "trainingQuiz", label: "Training Quiz" },
    { key: "customTaskCreateHelper", label: "Custom Task Create Helper" },
    { key: "referenceCheck", label: "Reference Check" },
  ];

  const canViewCustomTask =
    hasPermission("AccountSetting", "Custom Task", "view") ||
    hasPermission("AccountSetting", "Custom Task", "edit");

  const canViewReferenceCheck =
    hasPermission("AccountSetting", "Reference Check", "view") ||
    hasPermission("AccountSetting", "Reference Check", "edit") ||
    hasPermission("AccountSetting", "Reference Check", "delete");

  const visibleTabs = TABS.filter((tabItem) => {
    if (tabItem.key === "customTaskCreateHelper") return canViewCustomTask;
    if (tabItem.key === "referenceCheck") return canViewReferenceCheck;
    return true;
  });

  useEffect(() => {
    if (!visibleTabs.some((tabItem) => tabItem.key === tab)) {
      const fallbackTab = visibleTabs[0]?.key || "profile";
      setTab(fallbackTab);
      localStorage.setItem("accountSettingsTab", fallbackTab);
    }
  }, [tab, visibleTabs]);

  return (
    <div className="account-settings-container">
      {/* Left Sidebar (page-local) */}
      <div className="admin-sidebar">
        <div className="admin-sidebar-title">Administration</div>
        <ul>
          {visibleTabs.map((t) => (
            <li key={t.key}>
              <button
                onClick={() => {
                  setTab(t.key);
                  localStorage.setItem("accountSettingsTab", t.key);
                }}
                className={tab === t.key ? "active" : ""}
              >
                {t.label}
              </button>
            </li>
          ))}
        </ul>
      </div>

      {/* Right Content */}
      <div className="account-settings-content">
        {tab === "profile" && (
          <>
            <EmployeeNumberConfigSection />
          </>
        )}
        {tab === "tags" && <TagEditorPage hideAssignTab={true} />}
        {tab === "dropdownManager" && <DropdownManager />}
        {tab === "interviewQuestion" && <InterviewManager />}
        {tab === "trainingQuiz" && <TrainingQuiz />}
        {tab === "customTaskCreateHelper" && <CustomTaskCreateHelper />}
        {tab === "referenceCheck" && <ReferenceCheckAdminPage />}
      </div>
    </div>
  );
};

export default AccountSettingsPage;
